module.exports = __webpack_public_path__ + "static/img/kr-logo.9e7f4a02.svg";